<template>
  <div>
    <h2 class="heading-3 mb-24 last:mb-0 md:mb-16">
      {{ i18n(translations.title) }}
    </h2>
    <ul class="mb-7 list-outside px-16 md:mb-24">
      <li class="mb-24 last:mb-0 md:mb-16">
        <span class="body-1">
          {{ i18n(translations.tip1) }}
        </span>
      </li>
      <li class="mb-24 last:mb-0 md:mb-16">
        <span class="body-1">
          {{ i18n(translations.tip2) }}
        </span>
      </li>
      <li class="mb-24 last:mb-0 md:mb-16">
        <span class="body-1">
          {{ i18n(translations.tip3) }}
        </span>
      </li>
    </ul>

    <div class="mb-24 flex flex-col md:flex-row">
      <RevButton
        class="mb-32 mt-40 md:mb-0 md:mr-24 md:mt-0"
        variant="primary"
        @click="handleBackButtonClick"
      >
        {{ i18n(translations.backButton) }}
      </RevButton>

      <PaymentIcons />
    </div>

    <p>
      <span class="text-static-default-mid body-2">
        {{ i18n(translations.footer) }}
      </span>
    </p>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import { PaymentIcons } from '~/scopes/payment'

import { CHECKOUT } from '../../routes-names'

import translations from './FailureInstructions.translations'

const i18n = useI18n()
const router = useRouter()

const handleBackButtonClick = () => {
  router.push({ name: CHECKOUT.PAYMENT })
}
</script>
